module.exports = __webpack_public_path__ + "static/media/adrive-gen8-banner.ced5b3ee.png";